import { styled } from 'styled-components';

export const TooltipRoot = styled.div<{ $position: { x: number; y: number }; $show?: boolean }>`
    position: fixed;
    left: ${({ $position }) => $position.x}px;
    top: ${({ $position }) => $position.y}px;
    transform: translate3d(-50%, 0, 0); /* GPU-friendly & stable */
    transform-origin: top center;
    will-change: transform, opacity;
    z-index: 9999;
    pointer-events: none;
    visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
    opacity: ${({ $show }) => ($show ? 1 : 0)};
    transition:
        opacity 120ms ease,
        visibility 0s ${({ $show }) => ($show ? '0s' : '120ms')};
    background: ${({ theme }) => theme.tooltipBackground};
    color: ${({ theme }) => theme.tooltipColor};
    padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)};
    border: ${({ theme }) => theme.tooltipBorder};
    border-radius: ${({ theme }) => theme.tooltipBorderRadius};
    box-shadow: ${({ theme }) => theme.tooltipShadow};
    white-space: nowrap;
    max-width: calc(100vw - 16px); /* don’t overflow viewport */
    font-size: 12px;
    line-height: 1.3;
`;

export const TooltipBlock = styled.div`
    display: block;
`;
export const TooltipInlineBlock = styled.span`
    display: inline-flex;
    vertical-align: middle;
`;
